<template>
    <div>
        <div class="margin-top-15">
            <vButton
                v-if="alltype != 'query'"
                theme="primary"
                class="margin-left-10"
                @click="uploadImage"
                >{{
                    $t("erp.product.image_upload", { defaultValue: "图片上传" })
                }}</vButton
            >
            <!-- <vButton class="margin-left-10" theme="warning" @click="downImage()">{{$t('global.common.batch_download',{defaultValue:'批量下载'})}}</vButton> -->
        </div>
        <Table
            class="margin-left-10 margin-right-10 margin-top-15"
            :columns="columns"
            :data="formList"
            size="small"
            @on-selection-change="handleChecked"
            ref="table"
            border
        ></Table>
        <!-- 图片弹框 -->
        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <vForm label-width="63" class="clearfix" ref="detailform">
                <vFormItem
                    :label="
                        $t('boss.purchase.is_main_image', {
                            defaultValue: '是否主图',
                        })
                    "
                >
                    <vRadio
                        trueValue="1"
                        :strict="false"
                        v-model="formData.isMaster"
                        class="margin-right-10"
                        >{{
                            $t("boss.purchase.correct", { defaultValue: "是" })
                        }}</vRadio
                    >
                    <vRadio
                        trueValue="0"
                        :strict="false"
                        v-model="formData.isMaster"
                        >{{
                            $t("boss.purchase.deny", { defaultValue: "否" })
                        }}</vRadio
                    >
                </vFormItem>
            </vForm>
            <compMutiUpload
                v-bind="getFileProps"
                @on-cancel="cancelUpload"
                @on-success="successData"
            ></compMutiUpload>
            <footer slot="footer" v-show="false"></footer>
        </vModal>
        <!-- 全局弹框 -->
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="modalProps.show = false"
            @on-confirm="modalProps = {}"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                @on-close="modalProps = {}"
                v-bind="modalProps"
                v-on="modalProps.on"
            ></component>
        </compModal>
    </div>
</template>
<script>
import { HttpRemovePic } from "@/service/purchase/purchase";

export default {
    props: ["alltype", "imageformdata"],
    data() {
        return {
            formList: [],
            operate: {
                id: null,
                title: "",
                show: false,
                component: null,
            },
            formData: {
                isMaster: 1,
            },
            modalProps: {},
        };
    },
    components: {
        compMutiUpload: () => import("@components/templates/mutiUpload"),
    },
    computed: {
        columns() {
            let _this = this;
            return [
                {
                    type: "selection",
                    width: 60,
                },
                {
                    title: this.$t("erp.product.thumbnail", {
                        defaultValue: "缩略图",
                    }),
                    render: (h, { row }) => {
                        return (
                            <div>
                                <img
                                    style="max-width: 150px;max-height: 60px"
                                    src={row.pictureUrl}
                                />
                            </div>
                        );
                    },
                },
                {
                    title: this.$t("global.common.name", {
                        defaultValue: "图片名称",
                    }),
                    render: (h, { row }) => {
                        return <div>{row.pictureName}</div>;
                    },
                },
                // {
                // 	title: "是否主图",
                // 	render: (h, { row }) => {
                // 		return <div>{row.isMaster == 1 ? '是' : '否'}</div>
                // 	}
                // },
                {
                    title: "URL",
                    render: (h, { row }) => {
                        return <div>{row.pictureUrl}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.is_main_image", {
                        defaultValue: "是否主图",
                    }),
                    key: "isMaster",
                    // tag:"vRadio",
                    width: this.alltype != "query" ? 150 : 0,
                    render: (h, { row, index }) => {
                        if (this.alltype != "query") {
                            if (row.isMaster == 1) {
                                return h(
                                    "vButton",
                                    {
                                        props: {
                                            theme: "error",
                                            size: "small",
                                        },
                                        style: {
                                            "margin-right": "15px",
                                        },
                                    },
                                    this.$t("boss.purchase.the_main_image", {
                                        defaultValue: "是主图",
                                    })
                                );
                            } else {
                                return h(
                                    "vButton",
                                    {
                                        props: {
                                            theme: "primary",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                this.updateDatalist(row, index);
                                            },
                                        },
                                        style: {
                                            "margin-right": "15px",
                                        },
                                    },
                                    this.$t("boss.purchase.select_main_image", {
                                        defaultValue: "选择为主图",
                                    })
                                );
                            }
                        } else {
                            return (
                                <div>
                                    {row.isMaster == 1
                                        ? this.$t("boss.purchase.correct", {
                                              defaultValue: "是",
                                          })
                                        : this.$t("boss.purchase.deny", {
                                              defaultValue: "否",
                                          })}
                                </div>
                            );
                        }
                    },
                },
                {
                    title: this.$t("global.common.operation", {
                        defaultValue: "操作",
                    }),
                    // width: this.alltype != 'query' ? 140 : 0,
                    render(h, { row, index }) {
                        let buttoncancel = "";
                        if (_this.alltype !== "query") {
                            buttoncancel = h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.comremove(index, row);
                                        },
                                    },
                                },
                                _this.$t("global.common.delete", {
                                    defaultValue: "删除",
                                })
                            );
                        }
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "primary",
                                        size: "small",
                                    },
                                    style: {
                                        marginRight: "5px",
                                    },
                                    on: {
                                        click: () => {
                                            _this.downImage(row);
                                        },
                                    },
                                },
                                _this.$t("global.common.download", {
                                    defaultValue: "下载",
                                })
                            ),
                            buttoncancel,
                        ]);
                    },
                },
            ];
        },
        getFileProps() {
            return {
                action:
                    process.env.VUE_APP_APIURL_UC +
                    "/api/v1/BizAttach/uploadFile",
                name: "multipartFile",
                // multiple: true,
                data: {
                    srcLabel: this.srcLabelid || 0,
                    model: "supplier_product",
                    type: "other",
                },
                beforeUpload: () => {
                    let flag = false;
                    console.log(
                        this.formData.isMaster,
                        "this.formData.isMaster"
                    );
                    this.formList.map((item) => {
                        if ((item.isMaster == this.formData.isMaster) === 1) {
                            flag = true;
                        }
                    });
                    if (flag) {
                        this.$VMessage.error(
                            this.$t("boss.purchase.image_already", {
                                defaultValue:
                                    "图片已经存在主图了，请删除后添加新主图!",
                            })
                        );
                        return false;
                    } else {
                        return true;
                    }
                },
            };
        },
    },
    methods: {
        updateDatalist(row, index) {
            this.formList.map((item, itemindex) => {
                if (itemindex == index) {
                    this.$set(this.formList, itemindex, {
                        ...item,
                        isMaster: 1,
                    });
                } else {
                    this.$set(this.formList, itemindex, {
                        ...item,
                        isMaster: 0,
                    });
                }
            });
        },
        handledata() {
            this.formList = this.imageformdata.pictures || [];
        },

        handleChecked(selection, row) {
            this.checkedId = selection.map((item) => {
                return item.pictureUrl;
            });
            // console.log(this.checkedId)
        },

        downImage(rowData) {
            let urls = rowData ? [rowData.pictureUrl] : this.checkedId;
            console.log(urls);
            if (!urls) {
                this.$VMessage.error(
                    this.$t("erp.product.choose_image", {
                        defaultValue: "请选择图片",
                    })
                );
                return;
            }

            this.handleWebfs(rowData.pictureUrl, {}, "download");
            // for (var i = 0; i < urls.length; i++) {
            //     var name = 'picture_' + i;
            //     var image = new Image();
            //     // 解决跨域 Canvas 污染问题
            //     image.setAttribute('crossOrigin', 'anonymous');
            //     image.crossOrigin = "Anonymous"

            //     image.onload = function () {
            //         var canvas = document.createElement('canvas');
            //         canvas.width = image.width;
            //         canvas.height = image.height;

            //         var context = canvas.getContext('2d');
            //         context.drawImage(image, 0, 0, image.width, image.height);

            //         var url = canvas.toDataURL(); // 得到图片的base64编码数据
            //         canvas.toDataURL('image/png');

            //         var a = document.createElement("a"); // 生成一个a元素
            //         var event = new MouseEvent("click"); // 创建一个单击事件
            //         a.download = name || "photo"; // 设置图片名称
            //         a.href = url; // 将生成的URL设置为a.href属性
            //         a.dispatchEvent(event); // 触发a的单击事件
            //     };
            //     image.src = urls[i];
            // }
        },

        comremove(index, row) {
            // console.log(row,'2322323233')
            if (this.type == "add") {
                this.modalProps = {
                    show: true,
                    alert: "error",
                    title: this.$t("boss.purchase.delete_image", {
                        defaultValue: "删除图片",
                    }),
                    width: 460,
                    // params:{pictureid:row.id},
                    ajaxRequest: async () => {
                        this.formList.splice(index, 1);
                        this.$VMessage.error(
                            this.$t("boss.purchase.deleted", {
                                defaultValue: "已删除",
                            })
                        );
                    },
                };
            } else {
                if (row.id) {
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: this.$t("boss.purchase.delete_image", {
                            defaultValue: "删除图片",
                        }),
                        width: 460,
                        params: { picture_id: row.id },
                        ajaxRequest: HttpRemovePic,
                        callback: () => {
                            this.formList.splice(index, 1);
                            this.$emit("on-update");
                        },
                    };
                } else {
                    this.modalProps = {
                        show: true,
                        alert: "error",
                        title: this.$t("boss.purchase.delete_image", {
                            defaultValue: "删除图片",
                        }),
                        width: 460,
                        // params:{id:row.id},
                        ajaxRequest: async () => {
                            this.formList.splice(index, 1);
                            this.$VMessage.error(
                                this.$t("boss.purchase.deleted", {
                                    defaultValue: "已删除",
                                })
                            );
                        },
                    };
                }
            }
        },
        uploadImage() {
            this.operate = {
                show: true,
                title: this.$t("erp.product.image_upload", {
                    defaultValue: "图片上传",
                }),
            };
        },
        successData(resData) {
            console.log(resData);
            let data = {
                id: resData.items[0].id,
                pictureName: resData.items[0].attachTitle,
                pictureUrl: resData.items[0].attachUrl,
                isMaster: this.formData.isMaster,
            };
            this.formList.push(data);
            this.formData.isMaster = 0;
            this.operate.show = false;
        },
        cancelUpload() {
            this.operate.show = false;
        },
    },
    watch: {
        imageformdata() {
            // if(this.alltype != 'query'){
            this.handledata();
            // }
        },
    },
};
</script>
